document.addEventListener('DOMContentLoaded', function() {
    const dialog = document.getElementById('expandable-menu');
    let focusableElements = [];
    let currentIndex = 0;
    
    dialog.addEventListener('toggle', function(event) {
        if (event.target.matches(':popover-open')) {
            setupFocusTrap();
            document.body.style.overflow = 'hidden';
        } else {
            cleanupFocusTrap();
            document.body.style.overflow = '';
        }
    });
    
    function setupFocusTrap() {
        updateFocusableElements();
        
        // Focus first element
        if (focusableElements.length > 0) {
            focusableElements[0].focus();
            currentIndex = 0;
        }
        
        document.addEventListener('keydown', handleKeyDown);
        dialog.addEventListener('toggle', handleDetailsToggle, true);
    }
    
    function updateFocusableElements() {
        const allFocusable = Array.from(dialog.querySelectorAll(
            'button, a[href], summary[tabindex="0"], [tabindex="0"]'
        ));
        
        focusableElements = allFocusable.filter(element => {
            // Check if element is visible
            const rect = element.getBoundingClientRect();
            const style = window.getComputedStyle(element);
            
            if (style.display === 'none' || style.visibility === 'hidden' || rect.height === 0) {
                return false;
            }
            
            // Check if inside closed details
            const details = element.closest('details');
            if (details && element.tagName !== 'SUMMARY' && !details.open) {
                return false;
            }
            
            return true;
        });
    }
    
    function handleKeyDown(e) {
        if (e.key === 'Escape') {
            dialog.hidePopover();
            return;
        }
        
        if (e.key === 'Tab') {
            e.preventDefault();
            
            if (focusableElements.length === 0) return;
            
            if (e.shiftKey) {
                currentIndex = currentIndex <= 0 ? focusableElements.length - 1 : currentIndex - 1;
            } else {
                currentIndex = currentIndex >= focusableElements.length - 1 ? 0 : currentIndex + 1;
            }
            
            focusableElements[currentIndex].focus();
        }
        
        // Handle Enter and Space for summary elements
        if ((e.key === 'Enter' || e.key === ' ') && e.target.tagName === 'SUMMARY') {
            e.preventDefault();
            e.target.click();
        }
    }
    
    function handleDetailsToggle(e) {
        const details = e.target;
        if (details.tagName === 'DETAILS') {
            setTimeout(() => {
                updateFocusableElements();
                const summary = details.querySelector('summary');
                currentIndex = focusableElements.indexOf(summary);
                if (currentIndex !== -1) {
                    summary.focus();
                }
                
                const baseLabel = details.getAttribute('data-base-label') || '';
                if (details.open) {
                    details.setAttribute('aria-label', `Stäng ${baseLabel}`);
                    details.setAttribute('aria-expanded', 'true');
                } else {
                    details.setAttribute('aria-label', `Öppna ${baseLabel}`);
                    details.setAttribute('aria-expanded', 'false');
                }
            }, 50);
        }
    }
    
    function cleanupFocusTrap() {
        document.removeEventListener('keydown', handleKeyDown);
        dialog.removeEventListener('toggle', handleDetailsToggle, true);
        focusableElements = [];
        currentIndex = 0;
    }
});